import { toServerDateTimeFormat, toServerFilterDate } from '@shiftnex/framework/src/libs/dayjs';
import dayjs from 'dayjs';

import duration from 'dayjs/plugin/duration';
import timezone from 'dayjs/plugin/timezone';
import utc from 'dayjs/plugin/utc';
import customParseFormat from 'dayjs/plugin/customParseFormat';
import isBetweenPlugin from 'dayjs/plugin/isBetween';
import updateLocale from 'dayjs/plugin/updateLocale';
import relativeTime from 'dayjs/plugin/relativeTime';
// import en from 'dayjs/locale/en';
import objectSupport from 'dayjs/plugin/objectSupport';
import weekOfYear from 'dayjs/plugin/weekOfYear';

export function initDayJsPlugins() {
  dayjs.extend(duration);
  dayjs.extend(utc);
  dayjs.extend(objectSupport);
  dayjs.extend(timezone);
  dayjs.extend(toServerDateTimeFormat);
  dayjs.extend(toServerFilterDate);
  dayjs.extend(customParseFormat);
  dayjs.extend(isBetweenPlugin);
  dayjs.extend(updateLocale);
  dayjs.extend(relativeTime);
  dayjs.extend(weekOfYear);

  // dayjs.updateLocale('en', {
  //   weekStart: 0,
  // });
  // dayjs.Ls.en.weekStart = 0;
  // dayjs.locale({
  //   ...en,
  //   weekStart: 0,
  // });
}
